import { render, staticRenderFns } from "./NodePalette.vue?vue&type=template&id=2342fb12&scoped=true&"
import script from "./NodePalette.vue?vue&type=script&lang=js&"
export * from "./NodePalette.vue?vue&type=script&lang=js&"
import style0 from "./NodePalette.vue?vue&type=style&index=0&id=2342fb12&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2342fb12",
  null
  
)

export default component.exports